import React from 'react';
// @ts-ignore
import styles from './RequestPayment.module.scss';
import Modal from '../Modal/Modal';
import RequestPayment from './RequestPayment';
import { useAppContext } from '../../Services/AppContext';
import { useTreatmentContext } from '../../Services/TreatmentContext';

interface RequestPaymentModalProps {
	opened: boolean;
	onClose: any;
	caseId: string;
}

export default function RequestPaymentModal(props: RequestPaymentModalProps) {
	const { opened, onClose, caseId } = props;
	const { translation } = useAppContext();
	const { isCase } = useTreatmentContext();

	return (
		<div>
			<Modal opened={opened} onClose={onClose} wrapChat={isCase}>
				<Modal.Header title={translation['base.requestPayment']} />
				<Modal.Content>
					<RequestPayment caseId={caseId} onSuccess={onClose} />
				</Modal.Content>
			</Modal>
		</div>
	);
}
